<div id='mainHeader' class="container-fluid mainMenu_Container">
  <div id='topHeader' class="row TopHeader_mainContainer">
    <div id='topHeaderLang' class="topHeaderLang_Container">
      <div class="container nopad">
        <div class="col-md-12 col-sm-12 col-12 nopad floatLeft">
          <p class="time" id="datetime">{{currentDate | date: 'full'}}</p>
        </div>
        <!-- <div class="col-md-3 col-sm-3 col-12 nopad floatLeft">
                    <p class="time" id="screenReader">
                      <i class="glyphicon glyphicon-volume-up marRight"></i> <a href="" style="color: white;"> Screen Reader Access</a>
                  </p>
                </div>
                <div class="col-md-3 col-sm-3 col-12 nopad floatLeft">
                    <ul style="list-style-type: none; padding: 0; margin: 0; display: flex;">
                      <li style="flex: 1; color: #fff;">
                          <p>Text Size</p>
                          <button>A<sub>-</sub></button>
                          <button>A</button>
                          <button>A<sub>+</sub></button>
                      </li>
                      <li style="flex: 1; color: #fff;">
                          <a href="" style="color: #eea412;">हिन्दी</a>
                      </li>
                  </ul>
                </div>
                <div class="col-md-3 col-sm-3 col-12 nopad floatLeft">
                    <a href='https://portal.aicte-india.org/partnerportal_enu' style="height: 24px;width: 150px;border-radius: 25px;background:#eea412;color: white;border: 2px solid white;font-size: 10px;float: right;margin-top: 3px;font-weight: 500;text-align: center;padding-top: 3px;">WEB PORTAL LOGIN</a>
                </div> -->
      </div>
    </div>
    <div class="container-fluid nopad topHeader_Container">
      <div class="container nopad">
        <div class="col-md-9 col-sm-6 col-xs-6 nopad floatLeft text-center">
          <a class="floatLeft" routerLink='/'><img class="logoImg" src="assets/images/logo_new.png" alt="Logo"></a>
          <a class="" routerLink='/'><img class="logoImg" src="assets/images/SLALogo.png" alt="Logo"></a>
          <a class="floatRight" routerLink='/'><img class="logoImg" src="assets/images/Parakhlogo.png" alt="Logo" style="margin: 0;"></a>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-6 nopad searchContainer floatRight">
          <!-- <form>
                        <div class="container-input">
                            <input type="text" list="psychology_theories_list" id="psychology_theories_search" class="search-term" placeholder="Search..">
                            <button type="submit" class="search-button" id="selectTheory">
                              <i class="fa fa-search"></i>
                          </button>
                        </div>
                    </form> -->

          <div *ngIf="!loggedIn">
            <div class="btn SLA_button" style="width: 100px;">
              <a>Register</a>
              <ul id="ul" class="SignInBox">
                <li class="home" style="margin-bottom: 5px;">
                  <a routerLink='/institute-register'>
                    <div class="arrow">Institute</div>
                  </a>
                </li>
                <li class="home" style="margin-bottom: 5px;">
                  <a routerLink='/student-register'>
                    <div class="arrow">Student</div>
                  </a>
                </li>
                <li class="home" style="margin-bottom: 5px;">
                  <a routerLink='/faculty-register'>
                    <div class="arrow">Faculty</div>
                  </a>
                </li>
                <!-- <li class="home" style="margin-bottom: 5px;">
                  <a routerLink='/hod-register'>
                    <div class="arrow">HOD</div>
                  </a>
                </li> -->

                <!-- <li class="home" style="margin-bottom: 5px;">
                                    <a routerLink='/register'>
                                        <div class="arrow">Experts</div>
                                    </a>
                                </li>
                                <li class="home" style="margin-bottom: 5px;">
                                    <a routerLink='/register'>
                                        <div class="arrow">Reviewer</div>
                                    </a>
                                </li> -->
              </ul>
            </div>
          </div>

          <div>
            <div class="btn SLA_button" *ngIf="loggedIn">
              <a style="color: #fff;" (click)="myProfile()">My Profile</a>
            </div>
            <div class="btn SLA_button">
              <a routerLink='/login' style="color: #fff;" *ngIf="!loggedIn">Login</a>
              <a style="color: #fff;" *ngIf="loggedIn" (click)="logout()">Logout</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div id="menuHeader" class="container">
    <div class="menuNav" style="height: 50px;padding: 0;box-shadow: 0px 0px 5px #7a7a7a;">
      <ul class="menuNav_list">
        <li class="menuNav_listItem"><a routerLink='/' href="" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">HOME</a></li>
        <li class="menuNav_listItem"><a routerLink='/aboutus' routerLinkActive="active">ABOUT US</a>
          <ul class="menuNav_subList">
              <li class="menuNav_subListItem">
                  <ul class="menuNav_subListContainer">
                    <li class="menuNav_subListContainer_Item"><a routerLink='/aboutus'>ABOUT US</a></li>
                    <li class="menuNav_subListContainer_Item"><a routerLink='/image-gallery'>IMAGE GALLERY</a></li>
                    <li class="menuNav_subListContainer_Item"><a routerLink='/video-gallery'>VIDEO GALLERY</a></li>
                    <li class="menuNav_subListContainer_Item"><a routerLink='/directory'>DIRECTORY</a></li>
                  </ul>
              </li>
          </ul>          
        </li>
        <li class="menuNav_listItem"><a routerLink='/specialization' href="" routerLinkActive="active">COURSE</a></li>
        <li class="menuNav_listItem"><a routerLink='/guidelines' routerLinkActive="active">GUIDELINES</a>
          <!-- <ul class="menuNav_subList">
              <li class="menuNav_subListItem">
                  <ul class="menuNav_subListContainer">
                      <li class="menuNav_subListContainer_Item"><a routerLink='/guidelines'>General
                              Guidelines</a></li>
                      <li class="menuNav_subListContainer_Item"><a routerLink='/guidelines'>AICTE
                              Guidelines</a>
                      </li>
                  </ul>
              </li>
          </ul> -->
        </li>
        <li class="menuNav_listItem"><a [routerLink]="['/bulletin']" routerLinkActive="router-link-active"
            routerLinkActive="active">BULLETIN</a>
          <ul class="menuNav_subList">
                        <li class="menuNav_subListItem">
                            <ul class="menuNav_subListContainer">
                                <li class="menuNav_subListContainer_Item"><a routerLink='/bulletin/announcements' routerLinkActive="active">ANNOUNCEMENTS</a></li>
                                <li class="menuNav_subListContainer_Item"><a routerLink='/bulletin/upcoming' routerLinkActive="active">UPCOMING EVENTS</a></li>
                                <li class="menuNav_subListContainer_Item"><a routerLink='/downloads'>DOWNLOADS</a></li>
                            </ul>
                        </li>
                    </ul>
        </li>
        <!-- <li class="menuNav_listItem"><a routerLink="/directory" routerLinkActive="active">DIRECTORY</a>
          <ul class="menuNav_subList">
              <li class="menuNav_subListItem">
                  <ul class="menuNav_subListContainer">
                      <li class="menuNav_subListContainer_Item"><a routerLink="/directory">SLA Staff</a></li>
                      <li class="menuNav_subListContainer_Item"><a routerLink="/directory">Institute</a></li>
                  </ul>
              </li>
          </ul>
        </li> -->
        <!-- <li class="menuNav_listItem"><a routerLink="/downloads" routerLinkActive="active">DOWNLOAD</a>
          <ul class="menuNav_subList">
              <li class="menuNav_subListItem">
                  <ul class="menuNav_subListContainer">
                      <li class="menuNav_subListContainer_Item"><a routerLink="/downloads">Instructions</a>
                      </li>
                      <li class="menuNav_subListContainer_Item"><a routerLink="/downloads">User Manual</a>
                      </li>
                      <li class="menuNav_subListContainer_Item"><a routerLink="/downloads">Sample Formats</a>
                      </li>
                      <li class="menuNav_subListContainer_Item"><a routerLink="/downloads">Reports</a></li>
                  </ul>
              </li>
          </ul>
      </li> -->
      <!-- <li class="menuNav_listItem"><a routerLink="/guidelines" routerLinkActive="active">GUIDELINES</a></li> -->
      <li class="menuNav_listItem"><a routerLink="/faq" routerLinkActive="active">FAQ</a>
          <!-- <ul class="menuNav_subList">
                <li class="menuNav_subListItem">
                    <ul class="menuNav_subListContainer">
                        <li class="menuNav_subListContainer_Item"><a routerLink="/faq">General</a></li>
                        <li class="menuNav_subListContainer_Item"><a routerLink="/faq">Student</a></li>
                        <li class="menuNav_subListContainer_Item"><a routerLink="/faq">Faculty</a></li>
                        <li class="menuNav_subListContainer_Item"><a routerLink="/faq">Institute</a></li>
                    </ul>
                </li>
            </ul> -->
      </li>
      <li class="menuNav_listItem"><a class="participant" routerLink='/institute-details' routerLinkActive="active">PARTICIPATION</a>
        <ul class="menuNav_subList">
            <li class="menuNav_subListItem">
                <ul class="menuNav_subListContainer">
                  <li class="menuNav_subListContainer_Item"><a routerLink='/institute-details'>INSTITUTE</a></li>
                </ul>
            </li>
        </ul>          
      </li>
        <li class="menuNav_listItem"><a routerLink="/contactus" routerLinkActive="active">CONTACT</a></li>
      </ul>
    </div>

  </div>
  <div>
